import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '90%',
        flexWrap: 'wrap',
    },
    heading: {
        fontSize: '1.3rem',
        flexBasis: '33.33%',
        fontFamily: 'Apple Color Emoji, Segoe UI Symbol, Arial',
        fontWeight: 300,
        color: 'orange',
    },
    body: {
        fontSize: '1rem',
        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, 
        sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        color: '#ccc',
        fontWeight: 300,
        width: '100%',
        '@media (max-width:600px)': {
            fontSize: '0.9rem',
        },
        '@media (min-width:1200px)': {
            fontSize: '1.1rem',
        }
    },
    image: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    icon: {
        color: 'whitesmoke',
    }

}));

const Skills = ({ type, skills, avatar }) => {
    const classes = useStyles();

    return (
        <List className={classes.root}>
            <ListItem>
                <ListItemAvatar>
                    <Avatar className={classes.image}>
                        <img className={classes.image}
                            rel="preload"
                            as="video"
                            alt="icons" src={avatar}></img>
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={type}
                    className={classes.heading} />
            </ListItem>
            <ListItem>
                <p className={classes.body}>{skills}</p>
            </ListItem>
        </List>
    );
}

export default Skills